// extracted by mini-css-extract-plugin
export var close = "tags-module--close--410a3";
export var tag = "tags-module--tag--397a2";
export var tags = "tags-module--tags--b7f8c";
export var tagsWrapper = "tags-module--tagsWrapper--d4fd7";
export var title = "tags-module--title--92171";